import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function BackButtonDesktop() {
  const navigate = useNavigate();

  return (
    <Button
      startIcon={<ArrowBack />}
      onClick={() => navigate(-1)}
      sx={{
        textTransform: 'none',
        mb: 2,
        color: 'text.secondary',
      }}
    >
      Indietro
    </Button>
  );
}

export default BackButtonDesktop;